module.exports = __webpack_public_path__ + "img/logo_largo_r2.6649386e.svg";